import React from "react";
import {RpcState} from "../util/RpcState";
import { ActionButton } from "../util/UI/ActionButton";

type Props = {
  isEditing: boolean,
  
  // This is used to show the save button as spinning if the RPC is outstanding.
  // The error message is not displayed.
  rpcState: RpcState,
  
  editLabel?: string,
  
  // Show this error message directly underneath the save/cancel buttons.
  // Optional, your UI might already be showing errors elsewhere.
  errorText?: string,
  onEdit: () => void,
  onCancel: () => void,
  onSave: () => void,
}

/**
 * An "Edit" button that turns into "Save" and "Cancel" buttons when clicked.
 * @param props
 * @constructor
 */
export const SaveCancelEditButtons = (props: Props) => {

  return <div className={'VerticalFlex'} style={{alignItems: 'end'}}>
    <div style={{display: 'flex', gap: 10}}>

      {!props.isEditing && <div>
        <ActionButton smaller onClick={props.onEdit}>
          {props.editLabel || 'Edit'}
        </ActionButton>
      </div>}

      {props.isEditing && <div>
        <ActionButton smaller secondary onClick={props.onCancel}>
          Cancel
        </ActionButton>
      </div>}

      {props.isEditing && <div>
        <ActionButton smaller onClick={props.onSave} rpcState={props.rpcState}>
          Save
        </ActionButton>
      </div>}

    </div>
 
    {props.errorText &&<div className={'ErrorText'}>{props.errorText}</div>}

  </div>

}